import Component from "@base/Component.js";
import privacyContent from "./privacyContent.js";

/**
 * Native privacy policy page (bilingual). Replaces the legacy
 * /sites/privacy fragment (see StaticPage.js, now unused).
 * props: { lang }
 */
export default class PrivacyPage extends Component {
  render() {
    const c = privacyContent[this.props.lang] || privacyContent.en;

    const sections = c.sections
      .map(
        (s) =>
          `<section class="about-section">
             <h3>${Component.escape(s.h)}</h3>
             ${s.body}
           </section>`
      )
      .join("");

    return `
      <article class="about">
        <header class="page-intro">
          <h1 class="page-intro__title">${Component.escape(c.title)}</h1>
          <p class="gallery-detail__subtitle">${Component.escape(c.subtitle)}</p>
          <div class="page-intro__rule"></div>
        </header>
        ${sections}
      </article>`;
  }
}
